export class WFECommunityResultDto {
    communityId: number;
    communityName: string;
    legalName: string;
    intacctCompanyId: string;
    locationName: string;
    managementCompanyName: string;
    status: string;

    displayCommunityText(propertyList: Array<string>, joinedBy: string): string {
        let displayText = '';
        propertyList.forEach((prop) => {
            const index = propertyList.indexOf(prop);
            displayText += this[prop];

            if (index !== propertyList.length - 1) {
                displayText += `${joinedBy} `;
            }
        });

        return displayText;
    }
}
